import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import i18n from 'config/i18n';

import { checkPinkIcon } from 'assets/images';
import useIsMobile from 'utils/useIsMobile';

import styles from './style.module.scss';

const language = {
  ru: 'titleRu',
  kk: 'titleKk',
  en: 'titleEn',
  cn: 'titleEn',
};

const SelectList = ({
  data = [],
  onChangeSelect,
  onChangeCheckbox,
  title1,
  title2,
  defaultTitle,
  type = 'select',
  isLoading = false,
}) => {
  const { t } = useTranslation('qr');
  const isMobile = useIsMobile();
  const [activeElement, setActiveElement] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAllCol1, setSelectAllCol1] = useState(false);

  const handleSelect = location => {
    setActiveElement(location.id);
    if (onChangeSelect) {
      onChangeSelect(location);
    }
  };

  const handleCheckboxChange = changeItem => {
    if (selectedItems.includes(changeItem)) {
      setSelectedItems(selectedItems.filter(item => item.id !== changeItem.id));
      onChangeCheckbox(selectedItems.filter(item => item.id !== changeItem.id));
    } else {
      setSelectedItems([...selectedItems, changeItem]);
      onChangeCheckbox([...selectedItems, changeItem]);
    }
  };

  const handleSelectAllCol1 = () => {
    setSelectAllCol1(!selectAllCol1);

    if (!selectAllCol1) {
      setSelectedItems(data);
      onChangeCheckbox(data);
    } else {
      setSelectedItems([]);
      onChangeCheckbox([]);
    }
  };

  useEffect(() => {
    setSelectAllCol1(false);
    setSelectedItems([]);

    if (onChangeCheckbox) {
      onChangeCheckbox([]);
    }
  }, [data, onChangeCheckbox]);

  return (
    <div className={styles.container}>
      {type === 'select' && (
        <div className={styles.typeSelect}>
          <div
            className={
              isMobile ? styles.titleContainerMobile : styles.titleContainer
            }>
            {defaultTitle}
          </div>
          <div className={styles.listWithScrollbar}>
            <div className={styles.selectList}>
              {data.length > 0 &&
                data.map(location => (
                  <div
                    key={location.id}
                    aria-hidden
                    className={clsx(
                      styles.el,
                      activeElement === location.id && styles.active,
                    )}
                    onClick={() => handleSelect(location)}>
                    <p style={{ fontSize: isMobile ? '14px' : '16px' }}>
                      {location[language[i18n.language]]}
                    </p>
                    {activeElement === location.id && (
                      <img src={checkPinkIcon} alt="check icon" />
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
      {type === 'checkbox' && (
        <div className={styles.typeCheckbox}>
          <div className={styles.titleContainer}>
            <div className={styles.col1}>
              <input
                type="checkbox"
                checked={selectAllCol1}
                onChange={handleSelectAllCol1}
                className={styles.col1Input}
              />
            </div>
            <div className={styles.col3}>{title1}</div>
            <div className={styles.col2}>{title2}</div>
          </div>
          <div className={isMobile ? styles.contentMobile : styles.content}>
            {!isLoading &&
              data &&
              data.length > 0 &&
              data.map(item => (
                <div
                  key={item.id}
                  className={clsx(
                    styles.checkboxList,
                    selectedItems.includes(item) && styles.active,
                  )}>
                  <div className={styles.col1}>
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(item)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </div>
                  <div className={styles.col3}>
                    {item[language[i18n.language]]}
                  </div>
                  <div className={styles.col2}>{item.id}</div>
                </div>
              ))}
            {!isLoading && data && data.length === 0 && (
              <div className={styles.emptyList}>{t('emptyListPostCode')}</div>
            )}
            {!isLoading && !data && (
              <div className={styles.emptyList}>{t('chooseCity')}</div>
            )}
            {isLoading && (
              <div className={styles.emptyList}>{t('loadingTitle')}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectList;
